import { AuthPage } from '@nexvia-logistics/ui';
import { STORAGE_MODULE_OFF_MESSAGE } from '@/shared/storage-module';

/** Same link-shaped footer button as `Login.tsx` (the design system has none — spec "Not adopted"). */
const LINK_CLASS = 'inline-flex min-h-11 cursor-pointer items-center border-0 bg-transparent p-0 text-ui-label text-primary hover:underline';

/**
 * NEX-1645 (plan 2026-10-20, Tarea 3.4) — what Login, Registro and the shell show while the module
 * is `off` (`GET /app/features`), instead of the sign-in, the sign-up or the panel. The same
 * `AuthPage` card those screens use, with no form. `onSignOut` only when there is a session, so a
 * signed-in depósito can leave (the shell's own "Cerrar sesión" is not drawn here).
 */
export default function StorageModuleOffPage({ onSignOut }: { onSignOut?: () => void }) {
  return (
    <AuthPage
      title="Próximamente"
      description={STORAGE_MODULE_OFF_MESSAGE}
      footer={
        onSignOut ? (
          <button type="button" onClick={onSignOut} className={LINK_CLASS}>
            Cerrar sesión
          </button>
        ) : undefined
      }
    >
      {null}
    </AuthPage>
  );
}
